import { createAsyncThunk } from '@reduxjs/toolkit';
import { Language, setLanguageInternal } from './localeSlice';
import i18n from 'i18next';

export const changeAppLanguage = createAsyncThunk(
  'locale/changeAppLanguage',
  async (lang: Language, { dispatch }) => {
    dispatch(setLanguageInternal(lang));

    localStorage.setItem('language', lang);

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  },
);
